import React, { createContext, useMemo } from "react";

type IContextValue = {
  heightFromTop: number;
  setHeightFromTop: (height: number) => unknown;
};

export const ProductTileViewImpressionUpperThresholdContext =
  createContext<IContextValue>({
    heightFromTop: 0,
    setHeightFromTop: () => 0,
  });
ProductTileViewImpressionUpperThresholdContext.displayName =
  "ProductTileViewImpressionUpperThresholdContext";

export const ProductTileViewImpressionUpperThresholdProvider: React.FC<
  React.PropsWithChildren<IContextValue>
> = ({ children, setHeightFromTop, heightFromTop }) => {
  const value = useMemo(() => {
    return {
      heightFromTop,
      setHeightFromTop,
    };
  }, [heightFromTop, setHeightFromTop]);

  return (
    <ProductTileViewImpressionUpperThresholdContext.Provider value={value}>
      {children}
    </ProductTileViewImpressionUpperThresholdContext.Provider>
  );
};
